import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './ActivityPositionPin.css';

export const validPosition = position => Number.isFinite(position?.latitude) &&
  Number.isFinite(position?.longitude) && position.latitude >= -90 &&
  position.latitude <= 90 && position.longitude >= -180 && position.longitude <= 180;

function PositionMap({ position, onClose }) {
  const container = useRef(null);
  const closeButton = useRef(null);
  useEffect(() => {
    const coordinates = [position.latitude, position.longitude];
    const map = L.map(container.current, { center: coordinates, zoom: 16, zoomControl: false });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19 }).addTo(map);
    L.control.zoom({ position: 'topright' }).addTo(map);
    const pin = L.divIcon({ className: 'activity-position-marker', html: '<span aria-hidden="true">📍</span>', iconSize: [28, 32], iconAnchor: [14, 32] });
    L.marker(coordinates, { icon: pin }).addTo(map);
    const resize = setTimeout(() => map.invalidateSize(), 200);
    closeButton.current?.focus();
    return () => { clearTimeout(resize); map.remove(); };
  }, [position.latitude, position.longitude]);
  useEffect(() => {
    const escape = event => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', escape);
    return () => document.removeEventListener('keydown', escape);
  }, [onClose]);
  return createPortal(<div className="activity-position-overlay" role="presentation"
    onClick={event => event.stopPropagation()}
    onMouseDown={event => { if (event.target === event.currentTarget) onClose(); }}>
    <div className="activity-position-dialog" role="dialog" aria-modal="true" aria-label="Activity position map">
      <div className="activity-position-dialog-header"><strong>Activity position</strong>
        <button ref={closeButton} type="button" aria-label="Close position map" onClick={onClose}>×</button>
      </div>
      <div ref={container} className="activity-position-map" aria-label="Map of activity position" />
      <p>📍 {position.latitude}, {position.longitude}</p>
    </div>
  </div>, document.body);
}

export default function ActivityPositionPin({ activity }) {
  const [open, setOpen] = useState(false);
  if (!validPosition(activity?.position)) return null;
  return <>
    <button className="activity-position-pin" type="button" aria-label="Show activity position on map" title="Show activity position on map"
      onClick={event => { event.stopPropagation(); setOpen(true); }}>📍</button>
    {open && <PositionMap position={activity.position} onClose={() => setOpen(false)} />}
  </>;
}
